var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};

// src/extenders/share-cart.js
var ShareCart = class extends HTMLElement {
  constructor() {
    super();
    __publicField(this, "getShareUrl", () => {
      fetch("/cart.js").then((response) => response.json()).then((cart) => {
        const checkoutUrl = `/checkouts/cn/${cart.token}?discount=${cart.discount_code || ""}`;
        this.shareUrl = `https://${window.location.hostname}${checkoutUrl}`;
        this.sendFeedback(this.shareUrl);
      }).catch((err) => {
        console.error("Failed to fetch or share checkout link: ", err);
      });
    });
    __publicField(this, "sendFeedback", (shareUrl) => {
      if (navigator.canShare) {
        try {
          navigator.share({
            title: window.cart.shareTitle,
            text: window.cart.shareText,
            url: shareUrl
          });
          this.shareButton.textContent = window.cart.shareLinkCopied;
          setTimeout(() => {
            this.shareButton.textContent = window.cart.shareButtonText;
          }, 3e3);
        } catch (error) {
          output.textContent = `Error: ${error.message}`;
          this.shareButton.textContent = window.cart.shareLinkError;
          setTimeout(() => {
            this.shareButton.textContent = window.cart.shareButtonText;
          }, 3e3);
        }
      } else {
        navigator.clipboard.writeText(this.checkoutUrl).then(() => {
          this.shareButton.textContent = window.cart.shareLinkCopied;
          setTimeout(() => {
            this.shareButton.textContent = window.cart.shareButtonText;
          }, 3e3);
        });
      }
    });
    this.shareCartElement = this;
    this.shareButton = this.shareCartElement.querySelector("button");
    this.shareUrl = null;
    this.shareButton.addEventListener("click", () => {
      this.getShareUrl();
    });
  }
};
if (customElements.get("share-cart") === void 0) {
  customElements.define("share-cart", ShareCart);
}
